// Read-only HTML renderer for Tiptap content — matches editor styling.
// Renders display_body HTML from trace_entries with proper glitchOS typography.

function ensureLinkAttributes(raw: string): string {
  return raw.replace(/<a\s/g, (match) => {
    let result = match
    if (!raw.includes('target=')) result = result.replace('<a ', '<a target="_blank" ')
    if (!raw.includes('rel=')) result = result.replace('<a ', '<a rel="noopener noreferrer" ')
    return result
  })
}

export function RichTextRenderer({ html }: { html: string }) {
  if (!html || html === "<p></p>") return null

  return (
    <div
      className="prose-renderer text-[14px] leading-relaxed text-white/70"
      dangerouslySetInnerHTML={{ __html: ensureLinkAttributes(html) }}
    />
  )
}
